import __request__ from "routing/request";
export function getMetrics(input_ids, fields, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.forwarder/forwarder/inputs/metrics", null, { "input_ids": input_ids, "fields": fields }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
